module.exports = __webpack_public_path__ + "static/nps-24dbd33da170ada0b8fadb3d4f6d32c8.png";